import { CountryDto } from "./countryDto";
import { ThematicDto } from "./thematicDto";
import { VideoTypeDto } from "./videoTypeDto";

export class SupportVideoDto {
  supportESId: string;
  supportId: number;
  categoryId: number;
  title: string;
  pathSupport: string;
  urlSupport: string;
  videoTypeId: number;
  language: string;
  listCountry: CountryDto[];
  listThematic: ThematicDto[];
  videoType: VideoTypeDto;
  dateSupport: string;
  link: string;
  numberDownload: number;
  numberView: number;
}
